import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with auth token
const apiClient = axios.create({
  baseURL: API,
});

// Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth API
export const authAPI = {
  googleLogin: async (token) => {
    const response = await apiClient.post('/auth/google', { token });
    return response.data;
  },
  getMe: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
};

// Listings API
export const listingsAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/listings', { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/listings/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post('/listings', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiClient.put(`/listings/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiClient.delete(`/listings/${id}`);
    return response.data;
  },
};

// Messages API
export const messagesAPI = {
  getConversations: async () => {
    const response = await apiClient.get('/messages');
    return response.data;
  },
  getMessages: async (conversationId) => {
    const response = await apiClient.get(`/messages/${conversationId}`);
    return response.data;
  },
  send: async (data) => {
    const response = await apiClient.post('/messages', data);
    return response.data;
  },
};

// Favorites API
export const favoritesAPI = {
  getAll: async () => {
    const response = await apiClient.get('/favorites');
    return response.data;
  },
  add: async (listingId) => {
    const response = await apiClient.post(`/favorites/${listingId}`);
    return response.data;
  },
  remove: async (listingId) => {
    const response = await apiClient.delete(`/favorites/${listingId}`);
    return response.data;
  },
};

// Users API
export const usersAPI = {
  getProfile: async (userId) => {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  },
  updateProfile: async (data) => {
    const response = await apiClient.put('/users/profile', data);
    return response.data;
  },
};

// Alerts API
export const alertsAPI = {
  getAll: async () => {
    const response = await apiClient.get('/alerts');
    return response.data;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/alerts/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post('/alerts', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiClient.put(`/alerts/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiClient.delete(`/alerts/${id}`);
    return response.data;
  },
  togglePause: async (id) => {
    const response = await apiClient.post(`/alerts/${id}/pause`);
    return response.data;
  },
  runNow: async (id) => {
    const response = await apiClient.post(`/alerts/${id}/run-now`);
    return response.data;
  },
  getResults: async (id) => {
    const response = await apiClient.get(`/alerts/${id}/results`);
    return response.data;
  },
};
